/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminImpersonateCodeExchangeRequest
 */
export interface AdminImpersonateCodeExchangeRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeRequest
     */
    codeVerifier: string;
}

/**
 * Check if a given object implements the AdminImpersonateCodeExchangeRequest interface.
 */
export function instanceOfAdminImpersonateCodeExchangeRequest(value: object): value is AdminImpersonateCodeExchangeRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('codeVerifier' in value) || value['codeVerifier'] === undefined) return false;
    return true;
}

export function AdminImpersonateCodeExchangeRequestFromJSON(json: any): AdminImpersonateCodeExchangeRequest {
    return AdminImpersonateCodeExchangeRequestFromJSONTyped(json, false);
}

export function AdminImpersonateCodeExchangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImpersonateCodeExchangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'codeVerifier': json['code_verifier'],
    };
}

export function AdminImpersonateCodeExchangeRequestToJSON(json: any): AdminImpersonateCodeExchangeRequest {
    return AdminImpersonateCodeExchangeRequestToJSONTyped(json, false);
}

export function AdminImpersonateCodeExchangeRequestToJSONTyped(value?: AdminImpersonateCodeExchangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'code_verifier': value['codeVerifier'],
    };
}

